import { Outlet } from "react-router-dom";
import { Header } from "@/components/landing/header";
import { Footer } from "@/components/landing/footer";

export const MainLayout = () => {
  return (
    <div className="min-h-svh flex flex-col bg-white">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};
